/* global define APP_CONFIG */
import { Record, List } from 'immutable';

const customersCanvasUrl = APP_CONFIG.ccUrl;
const defaultValues = {
  templateId: 0,
  contentUrl: '',
  contentName: '',
  description: '',
  previewId: 0,
  previewUrl: '',
  designTypeItemId: 0,
  designTypeItemName: '',
  sizeTypeItemId: 0,
  sizeTypeItemName: '',
  themeName:'',
  typeItemName:'',
};

function formatCustomersCanvasUrl(path) {
  const index = path.indexOf('UserDataFolder');
  let url = path.substring(index);
  url = url.replace(/\\/g, '/');
  return `${ customersCanvasUrl }/${ url }`;
}

export default class DesignTemplate extends Record(defaultValues, DesignTemplate) {
  constructor(values) {
    super({
      ...values,
      previewUrl: values && values.previewUrl
                  ? formatCustomersCanvasUrl(values.previewUrl)
                  : defaultValues.previewUrl,
    });
  }

  static getDesignTemplateById(designTemplates, id) {
    return designTemplates.find((item) => {
      return item.get('templateId') === id ? item : undefined;
    });
  }

  static filterDesignTemplateById(designTemplates, id) {
    return designTemplates.filter((item) => {
      return item.get('templateId') === id;
    });
  }

  static getDesignTemplatesByTypeOrSizeId(designTemplates, id) {
    return designTemplates.find((item) => {
      return item.get('designTypeItemId') === id || item.get('sizeTypeItemId') === id? item : undefined;
    });
  }

  static getDesignTemplateByTypeAndSizeId(designTemplates, designTypeItemId, sizeTypeItemId) {
    return designTemplates.find((item) => {
      return item.get('designTypeItemId') === designTypeItemId && item.get('sizeTypeItemId') === sizeTypeItemId? item : undefined;
    });
  }

  static getPreDesignTemplateById(designTemplates, id) {
    let curindex = designTemplates.findIndex(item => item.get('templateId') === id);
    let preindex = curindex>0? curindex -1: curindex;
    return designTemplates.get(preindex);
  }

  static getNextDesignTemplateById(designTemplates, id) {
    let curindex = designTemplates.findIndex(item => item.get('templateId') === id);
    let nextindex = curindex<designTemplates.size-1? curindex+1: curindex;
    return designTemplates.get(nextindex);
  }

  static getDesignTemplateByDesignTypeId(designTemplates, id) {
    var result = designTemplates.filter((item) => {
      return item.get('designTypeItemId') === id;
    });
    return result;
  }

  static getDesignTemplatesByTypeAndSizeId(designTemplates, designTypeId, sizeTypeItemId) {
    let result = designTemplates.filter((item) => {
      return item.get('designTypeItemId') === designTypeId && item.get('sizeTypeItemId') === sizeTypeItemId;
    });
    return result;
  }
  static getDesignTemplatesByLayoutId(designTemplates, layoutId) {
    let result = designTemplates.filter((item) => {
      return item.get('contentName').startsWith(`${layoutId}_`) ;
    });
    return result;
  }

  static filterDesignTemplatesByTheme(designTemplates, themeName) {
    return designTemplates.filter((item) => {
      return item.get('themeName') === themeName;
    });
  }

  static filterDesignTemplatesByTypeItem(designTemplates, typeItemName) {
    return designTemplates.filter((item) => {
      return item.get('typeItemName') === typeItemName;
    });
  }

  static filterDesignTemplatesByThemeAndTypeItem(designTemplates, itemKey, itemValue) {
    return designTemplates.filter((item) => {
      return item.get('themeName') === itemKey && (this.filterTypeItemNameByValue(itemValue, item.get('typeItemName')).size > 0);
    });
  }

  static filterTypeItemNameByValue(itemValue, val) {
    return itemValue.filter((item) => {
      return item.get('filterValue') === val;
    });
  }

  static filterDesignTemplatesByIdOrThemeAndTypeItem(designTemplates, templateId, itemKey, itemValue) {
    return designTemplates.filter((item) => {
      return ( item.get('templateId') === templateId && item.get('themeName') === itemKey && (this.filterTypeItemNameByValue(itemValue, item.get('typeItemName')).size > 0) )
      || ( item.get('templateId') === templateId && ( item.get('themeName') !== itemKey ));
    });
  }

  static getDesignTemplatesInCurPage(designTemplates, onePageSize, currentPageNo) {
    return designTemplates.filter((item, ind) => {
      return ind >= ((currentPageNo-1)*onePageSize) && ind<currentPageNo*onePageSize;
    });
  }

  static distinctDesignTemplates(designTemplates) {
    /*let noDupDesignTemplates = new DesignTemplates();
    designTemplates.map((item) => {
      let newList = new DesignTemplates();
      newList = DesignTemplate.filterDesignTemplateById(noDupDesignTemplates, item.get('templateId'));
      if (newList.size === 0) {
        noDupDesignTemplates = noDupDesignTemplates.push(item);
      }
    });
    return noDupDesignTemplates;*/
    let noDupTemplateIdList = designTemplates.groupBy(x => x.get('templateId')).map(x => x.first()).toList();
    return noDupTemplateIdList;
  }

  static distinctTypeItemName(designTemplates) {
    let noDupTemplateIdList = designTemplates.groupBy(x => x.get('typeItemName')).map(x => x.first()).toList();
    return noDupTemplateIdList;
  }


}

export const DesignTemplates = (data) => {
  let designTemplates = new List();
  if (data) {
    data.forEach((value) => {
      designTemplates = designTemplates.push( (value instanceof DesignTemplate)? value: (new DesignTemplate(value)) );
    });
  }
  return designTemplates;
};
